import React from 'react';
import { Link } from 'react-router-dom';

interface BrandLogoProps {
  to?: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeClasses = {
  sm: 'text-base',
  md: 'text-lg sm:text-xl',
  lg: 'text-xl sm:text-2xl',
};

const BrandLogo: React.FC<BrandLogoProps> = ({ to = '/', size = 'md', className = '' }) => {
  const content = (
    <span className={`gp-brand inline-flex items-center gap-2 ${className}`}>
      <span className="gp-brand-mark" aria-hidden="true">
        <span className="gp-brand-mark-inner">GP</span>
      </span>
      <span className={`gp-brand-text font-display font-semibold tracking-tight ${sizeClasses[size]}`}>
        GlobalPreps
      </span>
    </span>
  );

  if (to) {
    return (
      <Link to={to} className="gp-brand group focus-visible:outline-none">
        {content}
      </Link>
    );
  }

  return content;
};

export default BrandLogo;
